module.exports = __webpack_public_path__ + "static/img/solutionDetailPic9.9e6fba3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic9.jpg
// module id = EgUG
// module chunks = 1